import { DefaultApi, Instrument } from '@digitalasset/cn-token-metadata-api-ts-client';
import { useQuery } from '@tanstack/react-query';
import { useCNAllocationApi } from '../../contexts/CNAllocationApiContext';

const fetchInstrumentsFromAllPages = async (
  instruments: Instrument[],
  tokenMetadataClient: DefaultApi,
  currentPageToken?: string,
): Promise<Instrument[]> => {
  const result = await tokenMetadataClient.listInstruments(undefined, currentPageToken);

  instruments.push(...result.instruments);

  if (result.nextPageToken) {
    return fetchInstrumentsFromAllPages(instruments, tokenMetadataClient, result.nextPageToken);
  }

  return instruments;
};

export const useCNGetAllInstrumentConfigurations = () => {
  const { tokenMetadataClient } = useCNAllocationApi();

  return useQuery({
    queryKey: [tokenMetadataClient, 'getCNInstrumentConfigurations'],
    queryFn: async () => {
      return fetchInstrumentsFromAllPages([], tokenMetadataClient);
    },
    refetchInterval: false,
  });
};
